import React, { lazy } from 'react';

const DiaryListing = lazy(() =>
  import('./Diary/DiaryListing').then(module => ({
    default: module.DiaryListing,
  })),
);

const MorningBriefingListing = lazy(() =>
  import('./MorningBriefing/MorningBriefingListing').then(module => ({
    default: module.MorningBriefingListing,
  })),
);

const MorningBrifiengForm = lazy(() =>
  import('./MorningBriefing/MorningBriefingForm').then(module => ({
    default: module.MorningBriefingForm,
  })),
);

const IncidentListing = lazy(() =>
  import('./Incident/IncidentListing').then(module => ({
    default: module.IncidentListing,
  })),
);

const IncidentForm = lazy(() =>
  import('./Incident/IncidentForm').then(module => ({
    default: module.IncidentForm,
  })),
);

const siteDiaryRoutes = [
  {
    props: { exact: true, path: '/site-diary/:siteID/morning-briefing' },
    component: <MorningBriefingListing />,
  },
  {
    props: { exact: true, path: '/site-diary/:siteID/morning-briefing/add' },
    component: <MorningBrifiengForm mode="add" />,
  },
  {
    props: { exact: true, path: '/site-diary/:siteID/incident' },
    component: <IncidentListing />,
  },
  {
    props: { exact: true, path: '/site-diary/:siteID/incident/add' },
    component: <IncidentForm mode="add" />,
  },
  {
    props: { exact: true, path: '/site-diary/:siteID/:diaryID' },
    component: <DiaryListing />,
  },
];

export default siteDiaryRoutes;
